import { j as n } from "../../../jsx-runtime-B6kdoens.js";
import { c as u } from "../../../index-CROKJrb5.js";
import { c as p, f as l } from "../../../create-component-CBAeEoQ6.js";
import { useTabsState as f } from "../TabsState/index.js";
import { u as b } from "../../../react-B_GApDuV.js";
const g = u({
  base: "cur-w-full cur-list-none cur-flex",
  variants: {
    size: {
      sm: "cur-gap",
      md: "cur-gap-2",
      lg: "cur-gap-3"
    }
  }
}), j = p(
  "TabsList",
  l(
    ({ as: s, className: t, size: o, ...a }, e) => {
      const r = s || "div", { sizeAtom: i } = f(), c = b(i), m = o ?? c;
      return /* @__PURE__ */ n.jsx(
        r,
        {
          className: g({
            size: m,
            className: t
          }),
          ref: e,
          role: "tablist",
          ...a
        }
      );
    }
  )
);
export {
  j as TabsList
};
//# sourceMappingURL=index.js.map
